/* Helper Functions  */

function getParameterFromUrl(name) {
  var url = window.location.href;
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);
  if (!results || !results[2]) {
    return;
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function setParameterToUrl(name, value) {
  const url = new URL(window.location);
  url.searchParams.set(name, value);
  history.replaceState(null, '', url.toString());
}


if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.others = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper?.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';

      this.showSpecialMedia = false;
      this.specialMediaName = '';
      this.onSpecialChange = this.onSpecialChange.bind(this);
      document.querySelectorAll('.special-media-button').forEach(btn => btn.addEventListener('click', this.onSpecialChange));

      this.updateOthers = true;
    }

    onSpecialChange(event) {
      const specialMedia = event.currentTarget.dataset.specialMedia;
      this.showSpecialMedia = specialMedia !== '';
      this.specialMediaName = specialMedia;
      this.updateMedia();
      [].forEach.call(document.querySelectorAll('.special-media-button'), function (el) {
        if (el == event.currentTarget) {
          el.classList.add('active');
        } else {
          el.classList.remove('active');
        }
      });
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(false, '');
        this.setUnavailable();
      } else {
        this.toggleAddButton(!this.currentVariant.available, '');
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      if (this.updateOthers) {
        this.updateOther();
      }
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        }
        else if (fieldset.querySelectorAll('input').length) {
          const inputs = Array.from(fieldset.querySelectorAll('input'));
          const checkedInput = inputs.find((input) => {
            return input.checked ? input : null;
          });
          this.options.push(checkedInput.value);
          const labels = Array.from(fieldset.querySelectorAll('label'));
          labels.forEach((label) => {
            if (label.getAttribute('for') == checkedInput.id) {
              label.classList.add('active');
            }
            else {
              label.classList.remove('active');
            }
          });
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      this.others.forEach(other => {
        let fieldsets = other.querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelector(`input[value='${option}']`)) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        other.updateOthers = false;
        other.onVariantChange(false);
        other.updateOthers = true;
      });
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const productSlider = document.querySelector('.thb-product-detail .product-images');
      const thumbnails = document.querySelector('.thb-product-detail #Product-Thumbnails');

      let activeMediaId = `Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      if (productSlider && document.getElementById(activeMediaId)) {
        activeMediaId = this.getSimilarMediaOrVariantFeatured(productSlider, activeMediaId);
      }
      this.setActiveMedia(activeMediaId, productSlider, thumbnails);
    }

    getSimilarMediaOrVariantFeatured(productSlider, featuredMediaId) {
      const featuresMedia = document.getElementById(featuredMediaId);
      const featuredMediaAltCsv = parseMediaAltCsv(featuresMedia.dataset.mediaAlt);
      const featuredMediaAlias = featuredMediaAltCsv['Alias'];
      if (!featuredMediaAlias) {
        // Early return of the featured id because its media's alt doesn't contain Alias
        return featuredMediaId;
      }
      const featuredMediaOptions = [];
      for (const option of ['Option1', 'Option2', 'Option3']) {
        if (option in featuredMediaAltCsv) {
          featuredMediaOptions.push(option);
        }
      }

      var slides = productSlider.querySelectorAll('.product-images__slide');
      for (var i = 0; i < slides.length; i++) {
        var slide = slides[i];
        const slideAltCsv = parseMediaAltCsv(slide.dataset.mediaAlt);
        const slideAlias = slideAltCsv['Alias'];
        if (slideAlias != featuredMediaAlias) {
          // Skip slide due to the Alias mismatch
          continue;
        }
        let optionMismatch = false;
        for (const option of featuredMediaOptions) {
          if (!(option in slideAltCsv)) {
            continue;
          }
          if (featuredMediaAltCsv[option] == slideAltCsv[option]) {
            continue;
          }
          optionMismatch = true;
          break;
        }
        if (optionMismatch) {
          // Skip slide due to the mismatch of one of the options
          continue;
        }
        return '#' + slide.id;
      }
      // No similar slide found, returning the featured id
      return featuredMediaId;
    }

    setActiveMedia(mediaId, productSlider, thumbnails) {
      if (!this.hideVariants) {
        if (productSlider) {
          productSlider.selectCell(mediaId);
        }
        return;
      }

      if (this.showSpecialMedia) {
        const specialMediaName = this.specialMediaName;
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide'), function (slide) {
          const slideAltCsv = parseMediaAltCsv(slide.dataset.mediaAlt);
          if (slideAltCsv['Alias'] == specialMediaName) {
            slide.classList.add('is-active');
          }
          else {
            slide.classList.remove('is-active');
          }
        });
      }
      else {
        const slidesToReactivate = [];
        if (productSlider) {
          if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
            productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(productSlider.querySelectorAll('.is-initial-selected'), function (el) {
            el.classList.remove('is-initial-selected');
          });
          if (thumbnails) {
            [].forEach.call(thumbnails.querySelectorAll('.is-initial-selected'), function (el) {
              el.classList.remove('is-initial-selected');
            });
          }
          const activeMedia = productSlider.querySelector(mediaId);
          const activeMediaAltCsv = parseMediaAltCsv(activeMedia.dataset.mediaAlt);
          const activeMediaOptions = [];
          for (const option of ['Option1', 'Option2', 'Option3']) {
            if (option in activeMediaAltCsv) {
              activeMediaOptions.push(option);
            }
          }

          activeMedia.classList.add('is-active');
          if (thumbnails) {
            const activeThumbId = `#Thumb-${activeMedia.dataset.mediaId}`;
            const activeThumb = thumbnails.querySelector(activeThumbId);
            activeThumb.classList.add('is-active');
          }

          [].forEach.call(productSlider.querySelectorAll('.product-images__slide'), function (slide) {
            if (slide == activeMedia) {
              return;
            }
            slidesToReactivate.push(slide);
          });
        }

        // Update active slides in the standalone view
        const standaloneFeatured = document.querySelector('.thb-product-detail .product-image-slides--stanalone-featured');
        standaloneFeatured?.querySelectorAll('.product-images__slide').forEach(slide => slidesToReactivate.push(slide));

        // Update active slides in the VT Product Info Section
        document.querySelectorAll('.product-info-section-images__image').forEach(slide => slidesToReactivate.push(slide));

        const currentOptions = [
          ['Option1', this.currentVariant.option1],
          ['Option2', this.currentVariant.option2],
          ['Option3', this.currentVariant.option3]
        ];
        for (const slide of slidesToReactivate) {
          const mediaAltCsv = parseMediaAltCsv(slide.dataset.mediaAlt);
          let optionMismatch = false;
          for (const [optionName, optionValue] of currentOptions) {
            if (!(optionName in mediaAltCsv)) {
              continue;
            }
            if (mediaAltCsv[optionName] != optionValue) {
              optionMismatch = true;
              break;
            }
          }
          if (optionMismatch) {
            slide.classList.remove('is-active');
          }
          else {
            slide.classList.add('is-active');
          }
          if (thumbnails) {
            const thumbId = `#Thumb-${slide.dataset.mediaId}`;
            const thumb = thumbnails.querySelector(thumbId);
            if (thumb) {
              if (optionMismatch) {
                thumb.classList.remove('is-active');
              }
              else {
                thumb.classList.add('is-active');
              }
            }
          }
        }
      }

      this.setImageSetMedia();

      if (productSlider) {
        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);
      }
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      setParameterToUrl('variant', this.currentVariant.id);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available && pickUpAvailability.fetchAvailability) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButton = this.parentElement.querySelector('.single-add-to-cart-button');
      if (!submitButton) return;
      const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
      const submitButton_fixed = document.getElementById('AddToCartSticky');
      if (disable) {
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.classList.add('sold-out');
        submitButton.innerHTML = window.theme.variantStrings.soldOut;
        if (submitButtonText && text) submitButtonText.dataset.content = text;
      } else {
        submitButton.removeAttribute('disabled');
        submitButton.classList.remove('loading');
        submitButton.classList.remove('sold-out');
        const addToCartText = this.currentVariant.add_to_cart_text || window.theme.variantStrings.addToCart;
        submitButton.innerHTML = addToCartText;

        if (submitButtonText) {
          if (productTemplate?.includes('pre-order')) {
            submitButtonText.dataset.content = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.dataset.content = addToCartText;
          }
        }

        if (submitButton_fixed) {
          submitButton_fixed.innerHTML = addToCartText;
        }
      }
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton || !submitButtonText) return;
        submitButtonText.dataset.content = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();

      if (variant_data && this.currentVariant) {

        const selected_options = this.currentVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index + 1}`
          };
        });
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);


        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;

        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      if (this.variantData) {
        return this.variantData;
      }
      const _this = this;
      this.querySelectorAll('[type="application/json"]').forEach((element) => {
        const data = JSON.parse(element.textContent);
        if (!_this.variantData) {
          _this.variantData = data;
          return;
        }
        data.forEach((value, index) => {
          for (const key in value) {
            if (key in _this.variantData[index]) {
              continue;
            }
            _this.variantData[index][key] = value[key];
          }
        })
      });
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  function isMobile() {
    return window.matchMedia("(max-width: 768px)").matches;
  }
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.quickView = this.closest('#Product-Drawer-Content');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');
      this.progress_bar = this.product_container.querySelector('.flickity-progress--bar'),

        this.setOptions();
      // Start Slider
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container?.querySelectorAll('.product-thumbnail');
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.images = this.querySelectorAll('img');
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        cellAlign: this.quickView ? 'left' : 'right',
        adaptiveHeight: !this.quickView,
        initialIndex: '.is-active',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active',
        on: {
          ready: () => {
            this.images.forEach((img) => {
              img.addEventListener('lazyloaded', () => {
                this.flkty.resize();
              });
            });
          },
          dragStart: () => {
            this.flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none");
          },
          dragEnd: () => {
            this.flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all");
          }
        }
      };
      if (this.quickView) {
        this.options.wrapAround = false;
      }
      if (this.progress_bar) {
        this.options.on.scroll = (progress) => {
          progress = Math.max(0, Math.min(1, progress));
          this.progress_bar.style.width = progress * 100 + '%';
        };
      }
    }
    sortSlides() {
      const slideContainer = this;    // your actual selector
      const thumbContainer = document.querySelector('#Product-Thumbnails .product-thumbnail-container--inner');   // your actual selector

      // STEP 1: Get only Thumb elements and create an order map
      const thumbOrderMap = {};
      [...thumbContainer.children].forEach((thumbEl, index) => {
        const thumbId = thumbEl.id;
        if (!thumbId.startsWith('Thumb-template--')) return;

        const uniqueId = thumbId.replace(/^Thumb-template--[^-]+-/, '');
        thumbOrderMap[uniqueId] = index;
      });

      // STEP 2: Get only Slide elements (ignore arrows etc.)
      const slides = [...slideContainer.children].filter(slide =>
        slide.id.startsWith('Slide-template--')
      );

      // STEP 3: Sort Slide elements based on the Thumb index
      slides.sort((a, b) => {
        const idA = a.id.replace(/^Slide-template--[^-]+-/, '');
        const idB = b.id.replace(/^Slide-template--[^-]+-/, '');
        const orderA = thumbOrderMap[idA] ?? Infinity;
        const orderB = thumbOrderMap[idB] ?? Infinity;
        return orderA - orderB;
      });

      // STEP 4: Re-append sorted slides (only those, not the other children)
      slides.forEach(slide => slideContainer.removeChild(slide));
      slides.forEach(slide => slideContainer.appendChild(slide));

    }
    init() {
      // On mobile, before initializing flkty we want to move standalone featured slides
      // to the main container
      if (isMobile()) {
        const slidesToMove = document.querySelectorAll('.thb-product-detail .product-image-slides--stanalone-featured .product-images__slide');
        const productSlider = document.getElementById('Product-Slider');
        slidesToMove.forEach(el => {
          productSlider.prepend(el);
        });
        const thumbnailsToMove = document.querySelectorAll('.thb-product-detail .product-thumbnail--stanalone-featured .product-thumbnail');
        const productThumbnails = document.querySelector('.thb-product-detail .product-thumbnail-container--inner');
        thumbnailsToMove.forEach(el => {
          productThumbnails.prepend(el);
        });
      }

      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {
      this.flkty.destroy();
      this.sortSlides();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media');

        let next_slide = this.flkty.cells[index].element,
          next_media = next_slide.querySelector('.product-single__media');

        if (this.thumbnails) {
          let active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
            active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

          // this.thumbnails.forEach((item, i) => {
          //   item.classList.remove('is-initial-selected');
          // });
          // active_thumb.classList.add('is-initial-selected');

          requestAnimationFrame(() => {
            if (active_thumb.offsetParent === null) {
              return;
            }
            const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
              windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
            active_thumb.parentElement.scrollTo({
              left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
              top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
              behavior: 'smooth'
            });
          });
        }


        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

        // Play new video
        if (next_media.classList.contains('product-single__media-external-video')) {
          if (next_media.dataset.provider === 'youtube') {
            next_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "playVideo",
              args: ""
            }), "*");
          } else if (next_media.dataset.provider === 'vimeo') {
            next_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "play"
            }), "*");
          }
          next_media.querySelector('.product-single__media-external-video--play').setAttribute('hidden', true);
        } else if (next_media.classList.contains('product-single__media-native-video')) {
          next_media.querySelector('video').play();
        }
      });

      if (this.thumbnails) {
        setTimeout(() => {
          let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
          active_thumbs.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => {
              this.thumbnailClick(thumbnail, index);
            });
          });
          this.thumbnail_container.addEventListener('click', (e) => {
            let count = Math.min(Math.max(this.thumbnail_container.querySelectorAll('.is-active').length, 1), 4);
            this.thumbnail_container.style.setProperty('--thumbnail-width', (count * 63) + 19 + 'px');
            if (!this.thumbnail_container.classList.contains('extended')) {
              this.thumbnail_container.classList.add('extended');
            } else {
              if (e.target.nodeName == 'BUTTON') {
                this.thumbnail_container.classList.remove('extended');
              }
              e.preventDefault();
            }
            if (!this.thumbnail_container.classList.contains('extended')) {
              let active_thumb = this.thumbnail_container.querySelector('.is-initial-selected');
              setTimeout(() => {
                active_thumb.parentElement.scrollTo({
                  left: Math.max(active_thumb.offsetLeft, 0),
                  top: 0,
                  behavior: 'smooth'
                });
              }, 300);
            }
          });
        });
      }
    }
    thumbnailClick(thumbnail, index) {
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.form.reportValidity()) {
        return;
      }

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };


      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
          if (document.querySelector('.product-add-to-cart-sticky-modal')) {
            document.querySelector('.product-add-to-cart-sticky-modal').removeAttribute('open');
          }
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      },
      {
        id: 'cart-drawer-toggle-mobile',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
        if (section.id == 'Cart-Drawer') {
          elementToReplace.removeProductEvent();
          elementToReplace.notesToggle();
          elementToReplace.termsCheckbox();
          elementToReplace.updateFreeShipping();
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer'),
        search_drawer = document.getElementById('Search-Drawer');

      if (search_drawer.classList.contains('active')) {
        search_drawer.classList.remove('active');
      }
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.classList.remove('active');
        this.body.classList.remove('open-cc--product');
        if (document.getElementById('Cart-Drawer')) {
          this.body.classList.add('open-cc');
          document.getElementById('Cart-Drawer').classList.add('active');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        this.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/**
 *  @class
 *  @function PassKey
 */
if (!customElements.get('pass-key')) {
  customElements.define('pass-key', class PassKey extends HTMLElement {
    constructor() {
      super();
      this.code = this.dataset.code;
      if (this.dataset.variants) {
        this.variants = this.dataset.variants.split(",");
      }
      this.productForm = document.querySelector('product-form[data-section="' + this.dataset.section + '"]');
      this.enterCodeForm = this.querySelector('form');
      this.enterCodeInput = this.enterCodeForm.querySelector('input');
      this.registerButton = this.querySelector('.klavio-btn');
      const registerPopup = this.dataset.registerPopup;
      this.registerButton.addEventListener('click', function (event) {
        event.preventDefault();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', registerPopup]);
      });
      const _this = this;
      this.enterCodeForm.addEventListener('submit', function (event) {
        event.preventDefault();
        setParameterToUrl('passkey', _this.enterCodeInput.value);
        _this.applyPasskey();
        _this.others.forEach(other => {
          other.applyPasskey();
        });
      });
      this.enterCodeButton = this.querySelector('.enter-code-btn');
      this.enterCodeButton.addEventListener('click', function (event) {
        this.classList.add('is-hidden');
        _this.enterCodeForm.classList.remove('is-hidden');
        _this.enterCodeInput.focus();
      });
      this.others = Array.from(document.querySelectorAll('pass-key')).filter((selector) => {
        return selector != this;
      });
      document.addEventListener('product:variant-change', (event) => {
        _this.applyPasskey();
      });
      this.applyPasskey();
    }
    applyPasskey() {
      const passkey = getParameterFromUrl('passkey');
      if (passkey !== this.code) {
        const variant = getParameterFromUrl('variant');
        if (!this.variants || this.variants.includes(variant)) {
          this.productForm.classList.add('is-hidden');
          this.classList.remove('is-hidden');
          return;
        }
      }
      this.productForm.classList.remove('is-hidden');
      this.classList.add('is-hidden');
    }
  });
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById(this.dataset.target);
      this.drawerToggleButton = this.querySelector('[type="button"]');
      this.drawerToggleButton.addEventListener('click', this.onClick.bind(this));
      this.addToCartButton = this.getElementsByTagName('product-form')[0];
      this.setupObservers();
      this.onDrawerHidden();
    }
    onClick() {
      this.drawer.show();
    }
    setupObservers() {
      let _this = this;
      let stickyObserver = new IntersectionObserver(function (entries) {
        let tatalIntersectionRatio = 0;
        entries.forEach((entry) => {
          tatalIntersectionRatio += entry.intersectionRatio;
        });
        if (tatalIntersectionRatio <= 0) {
          _this.classList.add('sticky--visible');
        } else {
          _this.classList.remove('sticky--visible');
        }
      }, {
        threshold: [0, 1]
      });
      document.querySelectorAll('.intersect-hide-product-add-to-cart-sticky').forEach((element) => {
        stickyObserver.observe(element);
      });
      let drawerObserver = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
              if (mutation.target.hasAttribute("open")) {
                _this.onDrawerShown();
              } else {
                _this.onDrawerHidden();
              }
          }
        }
      });
      drawerObserver.observe(this.drawer, {attributes: true});
    }
    onDrawerShown() {
      this.addToCartButton.classList.remove('is-hidden');
      this.addToCartButton.classList.add('is-visible');
      this.drawerToggleButton.classList.add('is-hidden');
      this.drawerToggleButton.classList.remove('is-visible');
    }
    onDrawerHidden() {
      this.addToCartButton.classList.add('is-hidden');
      this.addToCartButton.classList.remove('is-visible');
      this.drawerToggleButton.classList.remove('is-hidden');
      this.drawerToggleButton.classList.add('is-visible');
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function OptionLocator
 */
if (!customElements.get('option-locator')) {
  class OptionLocator extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.optionPosition = this.dataset.optionPosition;
      this.variantSelect = document.getElementById(`variant-selects-${this.dataset.section}`);
      const _this = this;

      const fieldsetInputs = this.querySelectorAll('fieldset input');
      fieldsetInputs.forEach(input => {
        input.addEventListener('change', event => {
          if (event.target.checked) {
            const input = _this.variantSelect.querySelector(`fieldset[data-index="option${_this.optionPosition}"] input[value="${event.target.value}"]`);
            if (!input.checked) {
              input.checked = true;
              _this.variantSelect.onVariantChange();
            }
          }
        });
      });
      document.addEventListener('product:variant-change', (event) => {
        const valueToFind = event.detail.variant[`option${_this.optionPosition}`];
        const input = _this.querySelector(`fieldset[data-index="option${_this.optionPosition}"] input[value="${valueToFind}"]`);
        input.checked = true;
      });
    }
  }

  customElements.define('option-locator', OptionLocator);
}

/**
 *  @class
 *  @function ProductTile
 */
if (!customElements.get('product-title')) {
  class ProductTile extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.titleText = this.dataset.title;
      this.connectionText = this.dataset.connectionText;
      this.suffixOption = this.dataset.suffixOption;
      this.optionsToIgnore = this.dataset.optionIgnore.split(',');
      this.titleElement = this.querySelector(".product-title");
      const _this = this;

      document.addEventListener('product:variant-change', (event) => {
        let optionText = event.detail.variant.option1;
        if (_this.suffixOption == "2") {
          optionText = event.detail.variant.option2;
        }
        else if (_this.suffixOption == "3") {
          optionText = event.detail.variant.option3;
        }
        for (const item of _this.optionsToIgnore) {
          if (optionText == item) {
            optionText = null;
            break;
          }
        }
        if (!optionText) {
          this.titleElement.innerHTML = this.titleText;
          return;
        }
        this.titleElement.innerHTML = this.titleText + " " + this.connectionText + " " + optionText;
      });
    }
  }

  customElements.define('product-title', ProductTile);
}

/**
 *  @class
 *  @function ProductInfoPopup
 */
if (!customElements.get('product-info-popup')) {
  class ProductInfoPopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.matchValue1 = this.dataset.matchValue1;
    this.matchValue2 = this.dataset.matchValue2;
    this.matchValue3 = this.dataset.matchValue3;
    this.initialOption1 = this.dataset.initialOption1;
    this.initialOption2 = this.dataset.initialOption2;
    this.initialOption3 = this.dataset.initialOption3;

    this.handlePopupToggles();
    this.updatePopupImages(this.initialOption1, this.initialOption3);
    this.bindVariantChangeEvents();
  }

  handlePopupToggles() {
    document.querySelectorAll('.open-popup').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const id = button.dataset.popupId;
        document.getElementById(id)?.classList.add('active');
      });
    });

    document.querySelectorAll('.close-popup').forEach(button => {
      button.addEventListener('click', () => {
        const id = button.dataset.popupId;
        document.getElementById(id)?.classList.remove('active');
      });
    });
  }

  parseAltAttributes(alt) {
    const matches = {};
    alt.split(',').forEach(part => {
      const [key, value] = part.split('=').map(str => str.trim());
      if (key && value) matches[key] = value;
    });
    return matches;
  }

  getProductImages() {
    return Array.from(document.querySelectorAll('.product-images__slide-image div img')).map(img => ({
      alt: img.alt,
      src: img.src
    }));
  }

  updatePopupImages(option1, option3) {
    // const matchValues = [
    //   this.matchValue1,
    //   this.matchValue2,
    //   this.matchValue3
    // ];

    // const images = this.getProductImages();
    // const matchedImages = [null, null, null];

    // images.forEach(img => {
    //   const parsed = this.parseAltAttributes(img.alt);
    //   matchValues.forEach((val, index) => {
    //     if (
    //       parsed["Option1"] === option1 &&
    //       parsed["Option3"] === val &&
    //       !matchedImages[index]
    //     ) {
    //       matchedImages[index] = img.src;
    //     }
    //   });
    // });

    // matchedImages.forEach((src, index) => {
    //   const imgEl = this.querySelector(`#popup-image-${index + 1}`);
    //   if (imgEl) {
    //     if (src) {
    //       imgEl.src = src;
    //       imgEl.style.display = "block";
    //       imgEl.nextElementSibling?.classList.add('hidden');
    //     } else {
    //       imgEl.src = "";
    //       imgEl.style.display = "none";
    //       imgEl.nextElementSibling?.classList.remove('hidden');
    //     }
    //   }
    // });
  }

  bindVariantChangeEvents() {
    document.addEventListener('product:variant-change', (event) => {
      this.updatePopupImages(event.detail.variant.option1, event.detail.variant.option3);
    });
  }
}

customElements.define('product-info-popup', ProductInfoPopup);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}

function parseMediaAltCsv(mediaAlt) {
  retval = [];
  mediaAlt.split(",").forEach(str => {
    const keyValue = str.split('=');
    if (keyValue.length != 2) {
      return;
    }
    const key = keyValue[0];
    const value = keyValue[1];
    retval[key] = value;
  });
  return retval;
}

const popup = document.getElementById('product-info-popup');
const headerWrap = document.querySelector('.header.style3 > .row > .header-wrap');

const observer = new MutationObserver(() => {
  if (popup.classList.contains('active')) {
    headerWrap.style.display = 'none';
  } else {
    headerWrap.style.display = '';
  }
});

observer.observe(popup, { attributes: true, attributeFilter: ['class'] });
